import getFullUrl from './getFullUrl';

export const getFallback = (src: string) =>
  getFullUrl(src.replace(/_([^_]*).webp$/, `.$1`));
